<form [formGroup]="form" (ngSubmit)="submit()">
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label for="name" class="label">Name</label>
        <input nbInput status="primary" fullWidth id="name" formControlName="name" placeholder="Enter journal name" />
        <p class="hint-text">
          Journal names will be prefixed with the location (e.g., "LocationName
          - {{ form.get('name')?.value || 'Name' }}")
        </p>
      </div>
      <div class="form-group">
        <label for="type" class="label">Type</label>
        <nb-select fullWidth id="type" formControlName="type" placeholder="Select journal type">
          <nb-option value="PhysicalCount">Physical Inventory</nb-option>
          <nb-option value="CycleCount">Cycle Count</nb-option>
          <nb-option value="Audit">Audit</nb-option>
        </nb-select>
        <p class="hint-text">
          Select the type of counting journal to create
        </p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group d-flex flex-column">
        <label for="blindCount" class="label">Options</label>
        <nb-checkbox formControlName="blindCount"> Blind Count </nb-checkbox>
        @if (form.get('blindCount')?.value) {
          <p class="hint-text">
            Expected quantities will be hidden during counting
          </p>
        }
        <nb-checkbox formControlName="requireConfirmSerial"> Require Serial Confirmation </nb-checkbox>
        @if (form.get('requireConfirmSerial')?.value) {
          <p class="hint-text">
            Serial number must be confirmed when counting equipment
          </p>
        }
      </div>
    </div>
  </div>

  <hr />
  <h6>Equipment Filters</h6>
  <div class="row pl-2 ">
    @for (filter of filters; track filter) {
      <div class="col-auto ml-0 p-0 pl-0">
        <next-slicer #slicer selectMode="multiple" [title]="filter.label" placeholder="Search"
          (onSlicerChange)="onSlicerChange(filter, $event)" (onSlicerClose)="getSlicerLabelsCounts($event)"
          optionsLabelKey="value" optionsValueKey="value" [slicerValues]="filter.values" [field]="filter.field"
        [isLoading]="filter.isLoading"></next-slicer>
      </div>
    }
    @if (showClearFilter) {
      <div class="col-auto m-1 p-0">
        <button nbButton ghost status="primary" (click)="clearFilters()">
          Clear Filters
        </button>
      </div>
    }
  </div>

  <next-object-list #equipmentList [object]="'Equipment'" page="EquipmentCountingJournalBatchCreate" [height]="400"
    [hideToolBar]="true" [hideQueues]="true" [showCheckbox]="true" [rowSelection]="'multiple'"
  (onSelect)="onEquipmentSelect($event)" (totalRecordCount)="onTotalCountChange($event)"></next-object-list>

  <br />

  <!-- Location counts when split by location is selected -->
  @if (form.get('splitByLocation')?.value) {
    <div class="location-counts-section">
      <h6 class="mb-1">Journals to be Created by Location</h6>
      @if (loadingLocationCounts) {
        <div class="loading-text">
          Loading location counts...
        </div>
      }
      @if (!loadingLocationCounts && locationCounts.length === 0) {
        <div class="no-data-text">
          No locations found for the selected equipment.
        </div>
      }
      @if (!loadingLocationCounts && locationCounts.length > 0) {
        <div class="location-counts-list">
          @for (loc of locationCounts; track loc) {
            <div class="location-chip">
              <span class="chip-name">{{ loc.value || '(No Location)' }}</span>
              <span class="chip-badge">{{ loc.count | number }}</span>
            </div>
          }
        </div>
      }
    </div>
  }
  <div class="total-counts">
    <div class="location-count-total">
      <span class="location-name"><strong>Total Equipment:</strong></span>
      <span class="location-count"><strong>{{ getTotalEquipmentCount() | number }}</strong></span>
    </div>
    <div class="location-count-total">
      <span class="location-name"><strong>Total Journals:</strong></span>
      <span class="location-count"><strong>{{ locationCounts.length | number }}</strong></span>
    </div>
  </div>

  <!-- Error message when equipment count exceeds limit -->


  <div class="form-actions mt-3">
    @if (isEquipmentCountExceeded) {
      <div class="error-message">
        Too many units selected ({{ totalEquipmentCount | number }}). Please reduce count to {{ MAX_EQUIPMENT_COUNT |
        number }} or fewer, or break into smaller batches.
      </div>
    }

    <button nbButton status="basic" type="button" (click)="close()">
      Cancel
    </button>
    <button nbButton status="primary" type="submit"
      [disabled]="form.invalid || totalEquipmentCount === 0 || isEquipmentCountExceeded">
      Create Journals
    </button>
  </div>
</form>